import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const CondolenceAdmin = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);

  useEffect(() => {
    fetch('/api/condolence/check', { credentials: 'include' })
      .then(res => { if (!res.ok) navigate('/condolence'); })
      .catch(() => navigate('/condolence'));
  }, [navigate]);

  const fetchOrders = useCallback(() => {
    setLoading(true);
    fetch(`/api/condolence/flower-orders?year=${year}&month=${month}`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => setOrders(data.orders || []))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [year, month]);

  // 初回読み込み
  useEffect(() => { fetchOrders(); }, [fetchOrders]);

  const formatDate = (d) => {
    if (!d) return '-';
    const dt = new Date(d);
    return `${dt.getFullYear()}/${dt.getMonth() + 1}/${dt.getDate()}`;
  };

  const formatAmount = (amount) => {
    if (!amount && amount !== 0) return '-';
    return `¥${Number(amount).toLocaleString()}`;
  };

  // 年の選択肢（今年±2年）
  const yearOptions = [];
  for (let y = now.getFullYear() - 2; y <= now.getFullYear() + 1; y++) {
    yearOptions.push(y);
  }

  return (
    <div className="form-page">
      <header className="form-header" style={{ background: '#37474f' }}>
        <button className="back-button" onClick={() => navigate('/condolence/menu')}>← 戻る</button>
        <h1>供花発注履歴（管理）</h1>
      </header>

      <main className="form-main">
        <div className="section-bar" style={{ background: '#eceff1' }}>
          <span className="icon">📊</span>
          <span className="title" style={{ color: '#37474f' }}>全店舗の供花発注一覧</span>
        </div>

        <div className="form-card">
          {/* 年月選択 */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
            <select value={year} onChange={e => setYear(Number(e.target.value))}
              style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }}>
              {yearOptions.map(y => <option key={y} value={y}>{y}年</option>)}
            </select>
            <select value={month} onChange={e => setMonth(Number(e.target.value))}
              style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px' }}>
              {[...Array(12)].map((_, i) => <option key={i + 1} value={i + 1}>{i + 1}月</option>)}
            </select>
            <button onClick={fetchOrders}
              style={{ padding: '8px 20px', background: '#37474f', color: 'white', border: 'none', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' }}>
              表示
            </button>
            <span style={{ marginLeft: '16px', fontSize: '13px', color: '#666' }}>
              {loading ? '読み込み中...' : `${orders.length}件`}
            </span>
          </div>

          {/* テーブル */}
          {!loading && orders.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#666' }}>該当月の発注履歴がありません</p>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #37474f' }}>
                    <th style={thStyle}>発注日時</th>
                    <th style={thStyle}>担当者</th>
                    <th style={thStyle}>店舗</th>
                    <th style={thStyle}>対象社員</th>
                    <th style={thStyle}>商品1</th>
                    <th style={thStyle}>商品2</th>
                    <th style={thStyle}>届け日</th>
                    <th style={thStyle}>金額</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map(order => (
                    <tr key={order.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={tdStyle}>{formatDate(order.created_at)}</td>
                      <td style={tdStyle}>{order.person_in_charge || '-'}</td>
                      <td style={tdStyle}>{order.department || '-'}</td>
                      <td style={tdStyle}>{order.employee_name}</td>
                      <td style={tdStyle}>{order.order1_product || '-'}</td>
                      <td style={tdStyle}>{order.order2_product || '-'}</td>
                      <td style={tdStyle}>{order.delivery_date || '-'}</td>
                      <td style={tdStyle}>{formatAmount(order.amount)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ borderTop: '2px solid #37474f' }}>
                    <td colSpan={7} style={{ ...tdStyle, textAlign: 'right', fontWeight: '600', color: '#37474f' }}>合計</td>
                    <td style={{ ...tdStyle, fontWeight: '600', color: '#37474f' }}>
                      {formatAmount(orders.reduce((sum, o) => sum + (o.amount || 0), 0))}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

const thStyle = {
  textAlign: 'left', padding: '10px 8px', color: '#37474f', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap'
};
const tdStyle = {
  padding: '10px 8px', fontSize: '13px', color: '#333', whiteSpace: 'nowrap'
};

export default CondolenceAdmin;
